module.exports = __webpack_public_path__ + "static/media/three.71a76268.png";